import React from "react";
import ReactDOM from "react-dom";
import App from "./components/App/AppWithMachine";
import "./tailwind.css";

ReactDOM.render(<App />, document.getElementById("root"));
